export const pathlist = [
  {
    id: "path24",
    d: "M52.1 425.9H584.4c76.8 0 152 55 228.6 55h75.2"
  },
  {
    id: "path23b",
    d: "M711.8 397.9c34.8-13.6 58.9-18.6 101.1-18.6h75.2"
  },
  {
    id: "path23a",
    d: "M52.1 425.9H584.4c34.7 0 69.7-10.4 104.4-20.8"
  },
  {
    id: "path22",
    d:
      "M52.1 425.9h306.8c74 0 72.2-97.5 148.8-97.5h76.7c76.6 0 152 152.4 228.6 152.4h75.2"
  },
  {
    id: "path21",
    d:
      "M52.1 425.9h306.8c74 0 72.2-97.1 148.8-97.5h76.7c75.8 0 152 50.6 228.6 50.9h75.2"
  },
  {
    id: "path20",
    d:
      "M52.1 425.9h306.8c74 0 72.2-97.5 148.8-97.5h76.7c75.8 0 152-50.7 228.6-50.7h75.2"
  },
  {
    id: "path19",
    d:
      "M52.1 425.9h306.8c74 0 73-97.5 148.8-97.5h76.7c75.8 0 152.8-152.8 228.6-152.8h75.2"
  },
  {
    id: "path18",
    d: "M52.5 323.8h531.9c76.6 0 152 152.5 228.6 152.4h75.2"
  },
  {
    id: "path17",
    d: "M52.5 323.8h531.9c75.8 0 152 50.9 228.6 50.9h75.2"
  },
  {
    id: "path16",
    d: "M52.5 323.8h531.9c76.6 0 152-50.4 228.6-50.4h75.2"
  },
  {
    id: "path15",
    d: "M52.5 323.8h531.9C661 323.8 737.2 171 813 171h75.2"
  },
  {
    id: "path14c",
    d: "M709.3 252.4c34.5 11 68.9 21 103.7 21h75.2"
  },
  {
    id: "path14b",
    d: "M439 264.4c17-21.1 36-39.8 69.1-39.8l76.2.1c34 0 67.8 9.6 101.5 20.3"
  },
  {
    id: "path14a",
    d: "M52.5 323.8l306.4-.2c32.3 0 49-19.7 66.3-41.5"
  },
  {
    id: "path13b",
    d:
      "M439 264.4c17-21.1 36-39.8 69.1-39.8l76.2.1c76.6 0 152-53.7 228.6-53.7h75.2"
  },
  {
    id: "path13a",
    d: "M52.5 323.8l306.4-.2c32.3 0 49-19.7 66.3-41.5"
  },
  {
    id: "path12",
    d:
      "M52.5 323.8h75.3c73.4 0 79.4-98.1 152.8-98.1H359c71.5 0 71.5 98.1 148.8 98.1h77.5c75 0 151.2 152.4 228.6 152.4h74.5"
  },
  {
    id: "path11",
    d:
      "M52.5 323.8H127c73.4 0 80.2-98.1 153.5-98.1h78.4c71.5 0 71.5 98.1 148.8 98.1h76.7c75.8 0 152 50.9 228.6 50.9h75.2"
  },
  {
    id: "path10",
    d:
      "M52.5 323.8H127c73.4 0 80.2-98.1 153.5-98.1h78.4c71.5 0 71.5 98.1 148.8 98.1h76.7c76.6 0 152-50.4 228.6-50.4h75.2"
  },
  {
    id: "path9",
    d:
      "M52.5 323.8H127c73.4 0 80.2-98.1 153.5-98.1h78.4c71.5 0 71.5 98.1 148.8 98.1h76.7C660.2 323.8 737.2 171 813 171h75.2"
  },
  {
    id: "path8b",
    d: "M709.3 252.4c34.5 11 68.9 21 103.7 21h75.2"
  },
  {
    id: "path8a",
    d:
      "M52.5 323.8H127c73.4 0 80.2-98.1 153.5-98.1h78.4l149.3-1h76.2c34 0 67.8 9.6 101.5 20.3"
  },
  {
    id: "path7",
    d:
      "M52.5 323.8H127c73.4 0 80.2-98.1 153.5-98.1h78.4l149.3-1h76.2c76.6 0 152-53.7 228.6-53.7h75.2"
  },
  {
    id: "path6",
    d:
      "M52.1 221.9H127l153.5-.5h78.4c73 0 73.1 97.9 148.8 97.9h76.7c76.6 0 152 152.2 228.6 152.2h75.2"
  },
  {
    id: "path5",
    d:
      "M52.1 221.9H127l153.5-.5h78.4c73 0 73 97.9 148.8 97.9h76.7c76.6 0 152.8-50.4 228.6-50.4h75.2"
  },
  {
    id: "path4",
    d:
      "M52.1 221.9H127l153.5-.5h78.4c73 0 73 97.7 148.8 97.9h76.7c76.6-.2 152 50.9 228.6 50.9h75.2"
  },
  {
    id: "path3",
    d:
      "M52.1 221.9H127l153.5-.5h78.4c73 0 73 97.9 148.8 97.9h76.7c76.6 0 152-152.8 228.6-152.8h75.2"
  },
  {
    id: "path2b",
    d: "M711.4 249.7c33.8 10.6 67.5 19.2 101.6 19.2h75.2"
  },
  {
    id: "path2a",
    d: "M52.1 221.9H127l153.5-.5H584.4c34.9 0 69.5 10.1 104.1 21"
  },
  {
    id: "path1",
    d: "M52.1 221.9H127l153.5-.5H584.4c75.8-1.1 152-55 228.6-55h75.2"
  }
];
